import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { TIMEZONE } from "../constans";

dayjs.extend(utc);
dayjs.extend(timezone);

/** Має збігатися з `formatPrReportSheetTitle` на сервері (укр. місяць + рік). */
export function formatPrReportSheetTitleClient(monthRef) {
    const m = dayjs(monthRef).isValid() ? dayjs(monthRef).tz(TIMEZONE) : dayjs().tz(TIMEZONE);
    const ms = m.startOf("month");
    const raw = ms.locale("uk").format("MMMM");
    const cap = raw.charAt(0).toUpperCase() + raw.slice(1);
    return `${cap} ${ms.format("YYYY")}`;
}

/**
 * Назва листа PR-звіту в Google (`formatPrReportSheetTitle` на бекенді): «Квітень 2026», «Травень 2026» …
 * Завжди від `monthRef`, щоб експорт за обраним місяцем потрапляв на відповідний таб.
 * (Фіксована підміна через env ламала багатолистові книги — оновлювався лише один лист.)
 */
export function getPrReportSheetTitleForMonth(monthRef) {
    return formatPrReportSheetTitleClient(monthRef);
}
